/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-06-15 10:10:41
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\layouts\IndexLayout\locales\en-US.ts
 */
export default {
  'index-layout.topmenu.userinfo': 'Personal Info',
  'index-layout.topmenu.logout': 'Logout',
  'index-layout.topmenu.notcertified': 'Not certified',
  'index-layout.topmenu.certifing': 'Under certification',
  'index-layout.topmenu.certified': 'Certified',
  'index-layout.topmenu.certifiedfail': 'Authentication failed',

  'index-layout.menu.home': 'Home',
  'index-layout.menu.home.workplace': 'Workplace',
  'index-layout.menu.home.custom-breadcrumbs': 'Custom bread crumbs',
  'index-layout.menu.home.custom-breadcrumbs.liqingsong.cc': 'liqingsong.cc',
  'index-layout.menu.home.docs': 'Using document',

  'index-layout.menu.component': 'Component',
  'index-layout.menu.component.icon': 'Icon',
  'index-layout.menu.component.icon.svg': 'IconSvg',
  'index-layout.menu.component.icon.font': 'IconFont',
  'index-layout.menu.component.editor': 'Editor',
  'index-layout.menu.component.editor.tui-editor': 'tui-editor',
  'index-layout.menu.component.editor.ckeditor': 'CKEditor',

  'index-layout.menu.pages': 'Page sample',
  'index-layout.menu.pages.list': 'List page',
  'index-layout.menu.pages.list.basic': 'Basis list',
  'index-layout.menu.pages.list.table': 'Table list',
  'index-layout.menu.pages.list.highly-adaptive-table': 'Highly adaptive table',
  'index-layout.menu.pages.list.search': 'Search list',
  'index-layout.menu.pages.list.search.table': 'Query list',
  'index-layout.menu.pages.form': 'Form page',
  'index-layout.menu.pages.form.basic': 'Basis Form',
  'index-layout.menu.pages.form.complex': 'Advanced Form',
  'index-layout.menu.pages.detail': 'Details page',
  'index-layout.menu.pages.detail.basic': 'Basic details',
  'index-layout.menu.pages.detail.module': 'Module details',
  'index-layout.menu.pages.detail.table': 'Table details',

  'index-layout.menu.roles': 'Permission to verify',
  'index-layout.menu.roles.all': 'All users have permissions',
  'index-layout.menu.roles.user': 'Users have permission',
  'index-layout.menu.roles.test': 'Tests have permission',

  'index-layout.menu.roles.personal': 'Personal center',
  'index-layout.menu.roles.personal.account': 'Account information',
  'index-layout.menu.roles.account': 'Account management',
  'index-layout.menu.roles.account.query': 'Account query',
  'index-layout.menu.roles.account.recharge': 'Recharge list',
  'index-layout.menu.roles.account.logistics': 'Logistics bill expense list',
  'index-layout.menu.roles.logistics': 'Logistics order management',
  'index-layout.menu.roles.logistics.sku': 'SKU management',
  'index-layout.menu.roles.logistics.erp': 'ERP management',
  'index-layout.menu.roles.logistics.query': 'Logistics doc query',
  'index-layout.menu.roles.logistics.collectbill': 'Collection management',
  'index-layout.menu.roles.logistics.address': 'Address setting',
};
